"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ML_DSA_87 = exports.ECDSA_SECP256K1_EVM = void 0;
/* eslint-disable @typescript-eslint/no-extraneous-class */
const secp256k1_1 = __importDefault(require("secp256k1"));
const sha3_1 = require("sha3");
const ml_dsa_1 = require("@noble/post-quantum/ml-dsa");
const binaryUtils_1 = require("./binaryUtils");
const utils_1 = require("@noble/post-quantum/utils");
const ECDSA_SECP256K1_EVM_SIGN_MAGIC = '\u0019Ethereum Signed Message:\n';
const keccak = new sha3_1.Keccak(256);
/**
 * EVM compatible signing scheme using keccak hash, magic bytes, and secp256k1 curve.
 */
exports.ECDSA_SECP256K1_EVM = {
    keccakHash(message, useEthereumMagic = true) {
        keccak.reset();
        keccak.update(useEthereumMagic ? Buffer.concat([
            Buffer.from(ECDSA_SECP256K1_EVM_SIGN_MAGIC + message.length),
            message
        ]) : Buffer.from(message));
        return keccak.digest('binary');
    },
    recoverPublicKey(signature, payload) {
        const signatureBuffer = Buffer.from(signature);
        const recoveryId = signatureBuffer.readUInt8(signatureBuffer.length - 1) - 27;
        return secp256k1_1.default.ecdsaRecover(signatureBuffer.subarray(0, signatureBuffer.length - 1), recoveryId, exports.ECDSA_SECP256K1_EVM.keccakHash(payload), false, Buffer.alloc);
    },
    createSignature(payload, privateKey) {
        const msgHash = exports.ECDSA_SECP256K1_EVM.keccakHash(payload);
        const sigObj = secp256k1_1.default.ecdsaSign(msgHash, privateKey);
        const result = Buffer.alloc(sigObj.signature.length + 1, Buffer.from(sigObj.signature));
        result.writeInt8(27 + sigObj.recid, result.length - 1);
        return result;
    },
    recoverSignerUserId(signature, payload) {
        const publicKey = exports.ECDSA_SECP256K1_EVM.recoverPublicKey(signature, payload);
        const pubKeyWithoutFirstByte = publicKey.subarray(1, publicKey.length);
        keccak.reset();
        keccak.update(Buffer.from(pubKeyWithoutFirstByte));
        const hashOfPubKey = keccak.digest('binary');
        return hashOfPubKey.subarray(12, hashOfPubKey.length);
    },
    verifySignature(expectedUserId, payload, signature) {
        try {
            const recoveredAddress = exports.ECDSA_SECP256K1_EVM.recoverSignerUserId(signature, payload);
            return (0, binaryUtils_1.areEqualBinaries)(recoveredAddress, expectedUserId);
        }
        catch {
            return false;
        }
    }
};
/**
 * Signing scheme using ML-DSA-87
 */
exports.ML_DSA_87 = {
    generateKeyPair() {
        const seed = (0, utils_1.randomBytes)(32);
        const keys = ml_dsa_1.ml_dsa87.keygen(seed);
        return {
            privateKey: keys.secretKey,
            publicKey: keys.publicKey,
        };
    },
    createSignature(payload, privateKey, seed) {
        return ml_dsa_1.ml_dsa87.sign(privateKey, payload, seed);
    },
    verifySignature(publicKey, payload, signature) {
        return ml_dsa_1.ml_dsa87.verify(publicKey, payload, signature);
    }
};
//# sourceMappingURL=signingUtils.js.map